import styled from 'styled-components';

export const MapWrapper = styled.div`
  height: 100%;
  width: 100%;
  container: google-map / size;

  .gm-style-iw.gm-style-iw-c,
  .gm-style-iw-d {
    max-height: none !important;
  }

  .gm-style-iw.gm-style-iw-c {
    padding: 0 !important;
    border-radius: 10px !important;
  }

  .gm-style-iw-d {
    overflow: hidden !important;
  }

  .gm-style-iw-chr {
    display: none;
  }
`;

export const MapUnavailableBox = styled.div`
  height: 100%;
  display: grid;
  place-items: center;
  background: ${(props) => props.theme.greyBackground};
  text-align: center;
  padding: 16px;
`;
